// Constants
export const FB_COVER_ASPECT_RATIO = 1.85366

// Enums
export const FbMember = Object.freeze({
  Profile: 'profile',
  Page: 'page',
  Group: 'group'
})

export const FbGroup = Object.freeze({
  Public: 0,
  Closed: 1,
  Secret: 2
})